import { AideAgricoleStubPage } from '../../../../components/aides/AideAgricoleStubPage';
import { getAideAgricoleStub } from '../../../../config/aides-agriculteurs';

export default function ExonerationCspePage() {
  const aide = getAideAgricoleStub('exoneration-cspe');
  if (!aide) return null;
  return <AideAgricoleStubPage aide={aide} />;
}
